import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import Login from "../components/login";
import Profile from "../components/profile";
import LogOut from "../components/logout";
import '../styles/main.scss'

//Main Container: Has the routes for binding flow
class App extends Component {
    render() {
      return (
          <Router>
              <div>
                  <Route exact path="/" component={Login} />
                  <Route path="/profile" component={Profile} />
                  <Route path="/logout" component={LogOut} />
              </div>
        </Router>
      )
    }
}

export default App;
